import { type ReactNode } from "react";
import classNames from "classnames";
import "./Tag.less";

export type TagVariant = "default" | "success" | "warn" | "primary" | "salesCampaign" | "backInStock";
interface TagProps {
  variant?: TagVariant;
  children: ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
  icon?: ReactNode;
  iconPosition?: "start" | "end";
}

const Tag = ({ children, variant = "default", as = "span", className, icon, iconPosition = "end" }: TagProps) => {
  const HtmlTag = as;

  return (
    <HtmlTag className={classNames(`scha__tag scha__tag--${variant}`, className)}>
      {iconPosition == "start" && icon}
      {children}
      {iconPosition == "end" && icon}
    </HtmlTag>
  );
};

export default Tag;
